import { createContext, PropsWithChildren, useState } from 'react';

import { RibbonContainer } from './RibbonContainer';

export interface RibbonMenuContext {
  hasIcon: boolean;
  setHasIcon: (hasIcon: boolean) => void;
}

export const RibbonMenuContext = createContext<RibbonMenuContext>({
  hasIcon: false,
  setHasIcon: () => {},
});

export const RibbonMenu = ({ children }: PropsWithChildren) => {
  const [hasIcon, setHasIcon] = useState(false);

  return (
    <RibbonMenuContext.Provider value={{ hasIcon, setHasIcon }}>
      <RibbonContainer orientation={'vertical'}>
        <div style={{ padding: '4px 0' }}>{children}</div>
      </RibbonContainer>
    </RibbonMenuContext.Provider>
  );
};
